import { render, staticRenderFns } from "./CookieNotification.vue?vue&type=template&id=2229020f&scoped=true&"
import script from "./CookieNotification.vue?vue&type=script&lang=js&"
export * from "./CookieNotification.vue?vue&type=script&lang=js&"
import style0 from "./CookieNotification.vue?vue&type=style&index=0&id=2229020f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2229020f",
  null
  
)

export default component.exports